import { isNil } from 'lodash';
import { useEffect, useRef } from 'react';
import { MaybeNil } from '../../utils/interfaces';
import { DataRefreshState } from '../../utils/apollo/graphqlSchema';

const useOnDataRefreshEndEffect = (
  dataRefreshState: MaybeNil<DataRefreshState>,
  callback: MaybeNil<() => void>,
) => {
  const prevDataRefreshStateRef = useRef<DataRefreshState | null>(null);

  // keep the callback in ref so changing it won't trigger the effect
  // that monitors the lastRefreshedAt (only lastRefreshedAt change is supposed to trigger it)
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (isNil(dataRefreshState)) {
      return;
    }
    if (
      prevDataRefreshStateRef.current !== null &&
      prevDataRefreshStateRef.current === DataRefreshState.Running &&
      dataRefreshState === DataRefreshState.Stable
    ) {
      callbackRef.current?.();
    }
    prevDataRefreshStateRef.current = dataRefreshState ?? null;
  }, [dataRefreshState]);
};

export default useOnDataRefreshEndEffect;
